
/**
 * 상품 타입
 */
export type OrderResponseItemType = typeof OrderResponseItemType[keyof typeof OrderResponseItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderResponseItemType = {
  COURSE: 'COURSE',
  EBOOK: 'EBOOK',
  SERVICE: 'SERVICE',
  SUBSCRIPTION: 'SUBSCRIPTION',
  DIGITAL_GOODS: 'DIGITAL_GOODS',
  OTHER: 'OTHER',
} as const;
